import joinClasses from "helpers/joinClasses";
import { Paragraph } from ".";

export const Loader = ({ className, ...props }) => {
  return (
    <Paragraph className={joinClasses("", className)}>Chargement...</Paragraph>
  );
};
